<template>
	<CardListSection
		:id="`block-${$vnode.key}`"
		v-bind="$props"
		class="c-block-list-related-content"
	/>
</template>

<script>
import CardListSection from '~/components/main/CardListSection';

export default {
	name: 'BlockListRelatedContent',
	components: {
		CardListSection,
	},
	inheritAttrs: false,

	props: {
		title: {
			type: String,
			default: null,
		},

		items: {
			type: Array,
			default: () => [],
		},

		link: {
			type: Object,
			default: null,
		},

		showTitleInToc: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
